<template lang="html">
  <el-row>
    <el-col :span="22" :offset="1">
      <el-row class="bg-eee pd-tb10 border-radio10">
          <el-col :span="22" :offset="1">
            <el-row class="pd-tb10">
              <el-input class="allWidth" placeholder="试题描述"></el-input>
            </el-row>
            <el-row class="pd-tb10">
              <el-radio v-model="radio" label="1">正确</el-radio>
              <el-radio v-model="radio" label="2">错误</el-radio>
            </el-row>
            <el-row class="fs12">
              解析:
            </el-row>
            <el-row class="pd-tb10">
              <el-col>
                <el-input
                  type="textarea"
                  class="allWidth"
                  :autosize="{ minRows: 2, maxRows: 4}"
                  placeholder="">
                </el-input>
              </el-col>
            </el-row>
          </el-col>
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'HdupJudge',
  data(){
    return {
      radio:'1'
    }
  }
}
</script>

<style lang="scss" scoped>
.center{
  display: flex;
  align-items: center;
}
.bg-eee{
      background: #eee;
}
.border-radio10 {
    border-radius: 10px;
}
</style>
